/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Panel, Text, Table } from 'shared/components'
import { EventsFilters } from './components/filters'

import * as styles from './styles'

const TransHistoryBeneComponent = ({ loadTransHistory, columns, onSearch }) => {
  return (
    <Panel>
      <div css={styles.reportHeader} data-testid="history-report-header">
        <div css={styles.reportTitle}>
          <Margin top={1} bottom={2}>
            <Text size={18} bold white>
              Transactions History
            </Text>
          </Margin>
        </div>
        <div css={styles.reportFilters}>
          <EventsFilters debounce={250} onSearch={onSearch} />
        </div>
      </div>
      <div css={styles.reportTable}>
        <Table
          id="transHistoryBene-table"
          columns={columns}
          loadData={loadTransHistory}
          showPageSizeOptions={false}
        />
      </div>
    </Panel>
  )
}

TransHistoryBeneComponent.propTypes = {
  loadTransHistory: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape()),
  onSearch: PropTypes.func.isRequired,
}

export default TransHistoryBeneComponent
